/**
 * 打刻のときに一緒に送る、端末の位置。
 *
 * **必ず答えを返す（失敗を投げない）。**位置が取れないことを理由に、打刻を止めない。
 * 取れなかったときは、理由（未許可・取得失敗・タイムアウト・非対応）を返す。
 *
 * 待つ時間の上限は8秒。ブラウザの許可の小窓を開いたまま放っておかれても、
 * その時間で打刻を送る（ブラウザ側の時間切れが効かない場合に備えて、こちらでも数える）。
 */

export const STAMPING_LOCATION_TIMEOUT_MS = 8000

const statusOfError = error => {
  const code = error && error.code
  if (code === 1) return 'DENIED'
  if (code === 3) return 'TIMEOUT'
  return 'UNAVAILABLE'
}

/**
 * @param {object} [options]
 * @param {Geolocation} [options.geolocation] 既定はブラウザのもの
 * @param {number} [options.timeoutMs]
 * @returns {Promise<{location_status: string, latitude?: number, longitude?: number, accuracy?: number}>}
 */
export const currentStampingLocation = (options = {}) => {
  const geolocation = 'geolocation' in options
    ? options.geolocation
    : (typeof navigator !== 'undefined' ? navigator.geolocation : null)
  const timeoutMs = options.timeoutMs || STAMPING_LOCATION_TIMEOUT_MS

  if (!geolocation || typeof geolocation.getCurrentPosition !== 'function') {
    return Promise.resolve({ location_status: 'UNSUPPORTED' })
  }
  return new Promise(resolve => {
    let done = false
    const finish = value => {
      if (done) return
      done = true
      clearTimeout(timer)
      resolve(value)
    }
    const timer = setTimeout(
      () => finish({ location_status: 'TIMEOUT' }), timeoutMs + 500)
    try {
      geolocation.getCurrentPosition(
        position => {
          const coords = (position && position.coords) || {}
          const latitude = Number(coords.latitude)
          const longitude = Number(coords.longitude)
          if (coords.latitude == null || coords.longitude == null ||
              !isFinite(latitude) || !isFinite(longitude)) {
            finish({ location_status: 'UNAVAILABLE' })
            return
          }
          const accuracy = Number(coords.accuracy)
          const result = { location_status: 'OK', latitude, longitude }
          if (coords.accuracy != null && isFinite(accuracy) && accuracy >= 0) {
            result.accuracy = accuracy
          }
          finish(result)
        },
        error => finish({ location_status: statusOfError(error) }),
        { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 0 }
      )
    } catch (error) {
      finish({ location_status: 'UNAVAILABLE' })
    }
  })
}
